import { UserStats } from '@/types';

export class Header {
  private element: HTMLElement;
  private clockInterval: number | null = null;

  constructor(private stats: UserStats) {
    this.element = document.createElement('header');
    this.render();
    this.startClock();
  }

  private render(): void {
    this.element.className = 'header';
    this.element.innerHTML = `
      <div class="container">
        <div class="card p-6">
          <div class="flex items-center justify-between">
            <div>
              <h1 class="font-bold text-3xl mb-2" style="color: var(--text-primary);">🔥 Streaks</h1>
              <p style="color: var(--text-secondary);">Track your habits and build momentum</p>
            </div>
            <div class="flex items-center gap-6">
              <div class="text-center clock-display">
                <div class="font-bold text-lg" id="current-time" style="color: var(--accent);"></div>
                <div class="text-sm" id="current-date" style="color: var(--text-secondary);"></div>
              </div>
              <div class="text-center">
                <div class="font-bold text-xl" style="color: var(--accent);">${this.stats.totalPoints}</div>
                <div class="text-xs" style="color: var(--text-secondary);">Points</div>
              </div>
              <div class="text-center">
                <div class="font-bold text-xl" style="color: var(--accent);">Level ${this.stats.level}</div>
                <div class="text-xs" style="color: var(--text-secondary);">Current Level</div>
              </div>
              <div class="text-center">
                <div class="font-bold text-xl" style="color: var(--accent);">${this.stats.currentStreak}</div>
                <div class="text-xs" style="color: var(--text-secondary);">Current Streak</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  private startClock(): void {
    this.updateClock();
    this.clockInterval = window.setInterval(() => {
      this.updateClock();
    }, 1000);
  }

  private updateClock(): void {
    const now = new Date();
    
    const timeElement = document.getElementById('current-time');
    const dateElement = document.getElementById('current-date');
    
    if (timeElement && dateElement) {
      const timeOptions: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      };
      
      const dateOptions: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      
      timeElement.textContent = now.toLocaleTimeString('id-ID', timeOptions);
      dateElement.textContent = now.toLocaleDateString('id-ID', dateOptions);
    }
  }

  public updateStats(stats: UserStats): void {
    this.stats = stats;
    this.render();
    this.updateClock();
  }

  public destroy(): void {
    if (this.clockInterval) {
      clearInterval(this.clockInterval);
      this.clockInterval = null;
    }
  }

  public getElement(): HTMLElement {
    return this.element;
  }
}